/**
 * List of endpoint path patterns that have been migrated to v2.
 * Dynamic segments use :param notation (e.g. :id, :uuid, :mlsId).
 * The interceptor uses these patterns to rewrite api/v1/ → api/v2/ transparently.
 *
 * To add a new v2 endpoint, simply append its path (the segment after api/v1/) to this array.
 */
export const V2_ENDPOINTS: string[] = [
    // Properties
    'properties/:mlsId/similar-properties',
    'properties/nearby-properties',
    'properties/search-results',
    'properties/search-results/stats',
    'properties/search-suggestions',
    'properties/cities/popular-searches',
    'properties/cities/zip-codes',
    'properties/cities/schools',
    'properties/popular-states',
    'properties/popular-cities',
    'properties/popular-communities',
    'properties/share-property',
    'properties/view-and-save-count',
    'properties/:id/media',
    'properties/:id',
    // Saved searches
    'saved-searches/:uuid/properties',
    'saved-searches/:uuid/stats',
    'saved-searches/:uuid',
    // Forms
    'forms/basic-contact',
    'forms/basic-contact-buyer',
    'forms/basic-contact-seller',
    'forms/free-market-analysis',
    'forms/personalized-home-search',
    'forms/careers',
    'forms/mortgage',
    'forms/request-a-showing',
    'forms/property-question',
    'forms/take-a-tour',
    'forms/home-worth-check',
    'forms/unlock-home-value',
    // Sitemap
    'sitemap/listings',
    'sitemap/listings/paginated',
    'sitemap/listing-pages-count',
    'sitemap/listing-pages',
    'sitemap/listings/:state/:city/:county',
    'sitemap/cities/count',
    'sitemap/cities/:state/:city/communities/count',
    // Global settings
    'global-settings/website-layout',
    'global-settings/favicon',

    'autosearch-items/common',

    // Profile (property reads migrated from Mongo to Elasticsearch)
    'profile/favourites',
    'profile/hidden-properties',
    'profile/commented-properties',
    'profile/comments/:listing_id',
    'profile/claimed-properties',
    'profile/claimed-properties/:listing_id',
];

/**
 * Pre-compiled regex patterns derived from V2_ENDPOINTS.
 * :param segments are converted to [^/?]+ to match any non-slash, non-query value.
 * Trailing (\/|\?|$) ensures we match full path segments, preventing
 * short patterns like properties/:id from matching longer paths.
 *
 * Built once at module load time — not rebuilt per request.
 */
export const V2_ENDPOINT_PATTERNS: RegExp[] = V2_ENDPOINTS.map(
    (path) => new RegExp(`api/v1/${path.replace(/:([^/]+)/g, '[^/?]+')}(\\/|\\?|$)`),
);


